import React, { FC, useEffect, useState } from 'react';

// contexts
import {
    defaultEditorDetails,
    EditorContext,
    EditorContextModel,
    EditorDetailsModel,
} from '../../../../../context/EditorContext';

// models
import { FormulaDetailModel } from 'models/formula.model';

// components
import TestFormulaModal from './TestFormulaModal';

interface TestFormulaModalContextProps {
    handleClose: () => void;
    className?: string;
    activeFormula?: FormulaDetailModel;
}
const TestFormulaModalContext: FC<TestFormulaModalContextProps> = ({
    handleClose,
    className,
    activeFormula,
}) => {
    const [editorDetails, setEditorDetails] =
        useState<EditorDetailsModel>(defaultEditorDetails);

    useEffect(() => {
        if (activeFormula) {
            setEditorDetails((prevState) => ({
                ...prevState,
                formula: activeFormula,
                formulaType: activeFormula.message_type,
            }));
        }
    }, [activeFormula]);

    return (
        <EditorContext.Provider
            value={{ editorDetails, setEditorDetails } as EditorContextModel}
        >
            <TestFormulaModal handleClose={handleClose} className={className} />
        </EditorContext.Provider>
    );
};

export default TestFormulaModalContext;
